import { resolveComponent as _resolveComponent, withKeys as _withKeys, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center" }
const _hoisted_2 = { class: "focus:outline-none overflow-hidden rounded-lg bg-white shadow-xl ring-1 ring-black ring-opacity-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "flex flex-col items-center truncate px-3 py-3 text-center font-semibold leading-tight text-gray-900 -md:py-6" }, " Pesquisando... ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "flex flex-col items-center truncate px-3 py-3 text-center font-semibold leading-tight text-gray-900 -md:py-6" }, " Nenhum resultado encontrado. ", -1)
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "w-full truncate px-3 text-left font-medium text-gray-900" }
const _hoisted_7 = {
  key: 0,
  class: "w-full truncate px-3 text-left text-sm font-medium text-gray-500"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "h-8" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!

  return (_openBlock(), _createBlock(_component_Menu, {
    as: "div",
    class: "relative z-10 inline-block w-full text-left"
  }, {
    default: _withCtx(({ open }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_Input, {
          modelValue: _ctx.search,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
          label: _ctx.label,
          labelClass: _ctx.labelClass,
          placeholder: _ctx.placeholder,
          mask: _ctx.mask,
          isIncorrect: _ctx.isIncorrect,
          incorrectMessage: _ctx.incorrectMessage,
          disabled: _ctx.disabled,
          class: _normalizeClass(`${open && 'custom-border'}`),
          onInput: _cache[1] || (_cache[1] = 
          () => {
            if (_ctx.search.length >= _ctx.minimumCharactersToShowList) {
              _ctx.searchFunction();
            }
          }
        ),
          onFocusin: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isOpen = true)),
          onFocusout: _ctx.closeDropdown,
          onKeydown: [
            _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.isOpen = false), ["esc"])),
            _cache[4] || (_cache[4] = _withKeys(($event: any) => (
          // @ts-ignore
          (event) => event.preventDefault()
        ), ["up"])),
            _cache[5] || (_cache[5] = _withKeys(($event: any) => (
          // @ts-ignore
          (event) => _ctx.handleKeyDown(event)
        ), ["down"]))
          ]
        }, null, 8, ["modelValue", "label", "labelClass", "placeholder", "mask", "isIncorrect", "incorrectMessage", "disabled", "class", "onFocusout"]),
        (!_ctx.search)
          ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
              key: 0,
              icon: _ctx.icons.search,
              class: "pointer-events-none absolute right-0 top-8 mr-3 mt-0.5 pt-px -md:top-10"
            }, null, 8, ["icon"]))
          : (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                key: 1,
                icon: _ctx.icons.loading,
                class: "pointer-events-none absolute right-0 top-8 mr-3 mt-1 animate-spin pt-px -md:top-10"
              }, null, 8, ["icon"]))
            : (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                key: 2,
                icon: _ctx.icons.cancel,
                class: "absolute right-0 top-8 mr-3 mt-1 cursor-pointer -md:top-10",
                onClick: _withModifiers(_ctx.reset, ["stop"])
              }, null, 8, ["icon", "onClick"]))
      ]),
      _createVNode(_Transition, {
        "enter-active-class": "transition ease-out duration-100",
        "enter-from-class": "transform opacity-0 scale-y-95",
        "enter-to-class": "transform opacity-100 scale-y-100",
        "leave-active-class": "transition ease-in duration-75",
        "leave-from-class": "transform opacity-100 scale-y-100",
        "leave-to-class": "transform opacity-0 scale-y-95"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_MenuItems, {
              static: "",
              class: "absolute right-0 z-10 -mt-4 mb-4 w-full origin-top-right"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  (_ctx.search.length < _ctx.minimumCharactersToShowList)
                    ? (_openBlock(), _createBlock(_component_MenuItem, {
                        key: 0,
                        as: "p",
                        class: "w-full truncate px-3 py-3 text-center text-sm font-medium text-gray-500"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Digite ao menos " + _toDisplayString(_ctx.minimumCharactersToShowList) + " caracteres para pesquisar ", 1)
                        ]),
                        _: 1
                      }))
                    : (_ctx.isLoading)
                      ? (_openBlock(), _createBlock(_component_MenuItem, { key: 1 }, {
                          default: _withCtx(() => [
                            _hoisted_3
                          ]),
                          _: 1
                        }))
                      : (_ctx.listValues.length === 0)
                        ? (_openBlock(), _createBlock(_component_MenuItem, { key: 2 }, {
                            default: _withCtx(() => [
                              _hoisted_4
                            ]),
                            _: 1
                          }))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.listValues?.slice(0, _ctx.listQuantity), (value, index) => {
                            return (_openBlock(), _createBlock(_component_MenuItem, {
                              key: index,
                              as: "div",
                              onFocusout: _ctx.closeDropdown
                            }, {
                              default: _withCtx(({ active }) => [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: _normalizeClass(["flex cursor-default flex-col items-center justify-start py-2 -md:py-4", [active && 'bg-gray-200', 'flex w-full items-center  text-gray-900']]),
                                  onKeydown: _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.focusInput && _ctx.focusInput(...args)), ["esc"])),
                                  onClick: ($event: any) => (_ctx.result(value))
                                }, [
                                  _createElementVNode("span", _hoisted_6, _toDisplayString(value.primaryText), 1),
                                  (value.secondaryText)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(value.secondaryText), 1))
                                    : _createCommentVNode("", true)
                                ], 42, _hoisted_5)
                              ]),
                              _: 2
                            }, 1032, ["onFocusout"]))
                          }), 128))
                ]),
                _hoisted_8
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, _ctx.isOpen]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}